import React, {useEffect} from 'react';

export const CdpScript = () => {
    useEffect(() => {
        if (typeof window === 'undefined') {
            return;
        }

        const _portalId = '564889152'; // Portal Kids Plaza
        const _propId = '564990546'; // Source: Website Ecom
        const _ATM_TRACKING_ASSOCIATE_UTM = 0;

        const init = () => {
            window._portalId = _portalId;
            window._propId = _propId;

            const _cdp365Analytics = {
                default_event: 0,
                first_party_domain: '.kidsplaza.vn',
            };

            if (window?.web_event) return;
            const a: any = (window.web_event = function () {
                a.queue.push(arguments);
            });
            a.propId = _propId;
            a.track = a;
            a.queue = [];
            const e = document.createElement('script');
            e.type = 'text/javascript';
            e.async = !0;
            e.src = '//st-a.cdp.asia/insight.js';
            const t = document.getElementsByTagName('script')[0];
            t.parentNode?.insertBefore(e, t);
        };

        // Defer CDP initialization to reduce TBT — load after page is interactive
        if ('requestIdleCallback' in window) {
            (window as any).requestIdleCallback(init, {timeout: 5000});
        } else {
            setTimeout(init, 3000);
        }

        // TODO-20: Fix accessibility of CDP365-injected elements.
        // CDP365 injects <a class="cdp365-element-link"> without text or aria-label.
        // This MutationObserver patches injected elements to add accessible names.
        const fixCdpAccessibility = () => {
            const observer = new MutationObserver(mutations => {
                for (const mutation of mutations) {
                    for (const node of mutation.addedNodes) {
                        if (node instanceof HTMLElement) {
                            const cdpLinks = node.querySelectorAll<HTMLElement>(
                                '.cdp365-element-link:not([aria-label])',
                            );
                            cdpLinks.forEach(link => {
                                link.setAttribute('aria-label', 'Promotional content from KidsPlaza');
                            });
                            // Also fix images without alt text in CDP containers
                            const cdpImages = node.querySelectorAll<HTMLImageElement>(
                                '[class*="cdp365"] img:not([alt]), [class*="ants-"] img:not([alt])',
                            );
                            cdpImages.forEach(img => {
                                img.setAttribute('alt', 'KidsPlaza promotion');
                            });
                        }
                    }
                }
            });
            observer.observe(document.body, {childList: true, subtree: true});
            return observer;
        };

        // Delay CDP accessibility fix until CDP script has had time to inject elements
        const accessibilityTimer = setTimeout(() => {
            fixCdpAccessibility();
        }, 6000);

        return () => {
            clearTimeout(accessibilityTimer);
        };
    }, []);

    return null;
};

export const CdpScriptInHead: React.FC = () => {
    return (
        <script
            dangerouslySetInnerHTML={{
                __html: `
                var _portalId = "564889152";
                var _propId = "564990546";
                var _ATM_TRACKING_ASSOCIATE_UTM = 0 ;

                var _cdp365Analytics = {
                        first_party_domain: ".kidsplaza.vn"
                }
                (function() {
                    var w = window;
                    if (w.web_event) return;
                    var a = window.web_event = function() {
                        a.queue.push(arguments);
                    }
                    a.propId = _propId;
                    a.track = a;
                    a.queue = [];
                    var e = document.createElement("script");
                    e.type = "text/javascript", e.async = !0, e.src = "//st-a.cdp.asia/insight.js";
                    var t = document.getElementsByTagName("script")[0];
                    t.parentNode.insertBefore(e, t)
                })();
                `,
            }}
        />
    );
};
